<template>
	<div class="ao-forms-wrap" >
		<div
			v-if="title"
			class="d-flex ao-forms-title"
			:class="{'ao-form-line' : !hideHeaderLine}"
		>
			<div class="ao-forms-header d-flex align-center w-100">
				<div class="d-flex flex-column">
					<span class="ao-h1">{{ title }}</span>
					<span
						v-if="subtitle"
						class="text-textMuted ao-p3-regular"
					>{{ subtitle }}</span>
				</div>
				<ao-icon-btn
					iconName="close"
					class="ml-auto"
					variant="text"
					@click="onCancel"
				/>
			</div>
		</div>
		<div class="ao-forms-content">
		<slot/>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FormsWrapper',
	props: {
		width: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: null,
		},
		subtitle: {
			type: String,
			default: null,
		},
		saveAndContinueBtn:{
			type: Boolean,
			default: null,
		},
		hideHeaderLine:{
			type: Boolean,
			default: null,
		},
		showFooter:{
			type: Boolean,
			default: false,
		}
	},
	emits: ['onSubmit', 'onCancel'],
	computed: {
		getWidth() {
			return this.width > 0 ? this.width : 300
		},
	},
	methods:{
		onSubmit(val){
			this.$emit('onSubmit',val)
		},
		onCancel(){
			this.$emit('onCancel')
		}
	}
}
</script>
<style lang="scss">
.ao-forms-wrap {
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: visible;
	height:100%;
	//padding-top: 40px;
}
.ao-forms-title{
	//position:absolute;
	//top:0;
}
.ao-forms-header{
	padding: 24px;
}
.ao-forms {
	padding: 24px;
	max-height:50vh;
	overflow: auto;
  overflow-x: hidden;
}
.ao-form-line {
	border-bottom: 1px solid #e6eef3;
}
.ao-forms-content{
 	height: calc(100% - 85px);
 //overflow: hidden;
}
.ao-tabs-content{
	height:calc(100% - 75px);
	//height:500px;
	overflow: auto;
}
.ao-form-tabs{
	height: calc(100% - 98px);
}
</style>
